import "../../App.css";
import ContactForm from "../ContactForm";
import Footer from "../Footer";
import Reveal from "../Reveal";
import Seo from "../Seo";
import "./Contact.css";

const DETAILS = [
	{
		label: "Adres",
		value: "Berkenhof 4, 4711RS Sint Willebrord",
		href: "http://maps.google.nl/?q=Berkenhof%204,%204711RS%20Sint%20Willebrord",
		external: true,
	},
	{
		label: "Telefoon",
		value: "06-18218292",
		href: "tel:0618218292",
	},
	{
		label: "E-mail",
		value: "info@vanvlimmerenfeestverhuur.nl",
		href: "mailto:info@vanvlimmerenfeestverhuur.nl",
	},
	{
		label: "KvK-nummer",
		value: "91703921",
	},
];

const MAPS_EMBED_SRC =
	"https://www.google.com/maps?q=Berkenhof%204%2C%204711RS%20Sint%20Willebrord&output=embed";

function Contact() {
	return (
		<>
			<Seo
				title="Contact"
				description="Neem contact op met Van Vlimmeren Feestverhuur — bel 06-18218292, mail info@vanvlimmerenfeestverhuur.nl of gebruik het contactformulier."
				path="/contact"
			/>
			<section className="contact-page-hero">
				<div className="contact-page-hero-inner">
					<div className="contact-page-hero-content">
						<span className="contact-page-eyebrow">CONTACT</span>
						<h1 className="contact-page-title">Neem contact op</h1>
						<div className="contact-page-rule" aria-hidden="true"></div>
						<p className="contact-page-subtitle">
							Vragen over decoratie, beschikbaarheid of een idee dat u
							wilt bespreken? We denken graag met u mee — wij nemen
							binnen 24 uur contact met u op.
						</p>
					</div>
					<div className="contact-page-hero-image">
						<img
							src={process.env.PUBLIC_URL + "/images-v2/contact/hero.webp"}
							alt="Verlichte letters Van Vlimmeren Feestverhuur"
							loading="eager"
						/>
					</div>
				</div>
			</section>

			<Reveal as="section" className="contact-page-details reveal--stagger">
				<div className="contact-page-details-grid">
					{DETAILS.map((d, i) => (
						<div
							key={d.label}
							className="contact-page-detail stagger-item"
							style={{ "--stagger-index": i }}>
							<span className="contact-page-detail-label">{d.label}</span>
							{d.href ? (
								<a
									href={d.href}
									className="contact-page-detail-value"
									{...(d.external
										? {
												target: "_blank",
												rel: "noopener noreferrer",
										  }
										: {})}>
									{d.value}
								</a>
							) : (
								<span className="contact-page-detail-value">
									{d.value}
								</span>
							)}
						</div>
					))}
				</div>
			</Reveal>

			<Reveal>
				<ContactForm
					emailSubject="Contactpagina"
					eyebrow="Formulier"
					formTitleText="Stuur ons een bericht"
				/>
			</Reveal>

			<Reveal as="section" className="contact-page-map">
				<div className="contact-page-map-header">
					<span className="contact-page-eyebrow">BEZOEK ONS</span>
					<h2 className="contact-page-map-title">Hier vindt u ons</h2>
					<p className="contact-page-map-subtitle">
						Uitsluitend op afspraak
					</p>
				</div>
				<div className="contact-page-map-frame">
					<iframe
						title="Locatie Van Vlimmeren Feestverhuur — Berkenhof 4, 4711RS Sint Willebrord"
						src={MAPS_EMBED_SRC}
						loading="lazy"
						allowFullScreen
						referrerPolicy="no-referrer-when-downgrade"
					/>
				</div>
			</Reveal>

			<Footer />
		</>
	);
}

export default Contact;
